import { Schema } from '../create/components/referee-form.schema';
import { RefereeForm } from '../create/components/referee-form';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useUpdateRefereeMutation } from '../mutation';
import { useParams } from '~/hooks/useParams';
import { useRefereeQuery } from '../queries';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';
import { JudgeWrite } from '~/apis/ssf';

export const Page = withPrivateRoute(() => {
  const { id } = useParams(idParamSchema.parse);
  const { data } = useRefereeQuery(id);

  const mutation = useUpdateRefereeMutation();
  const navigate = useNavigate();

  async function handleSubmit(payload: Schema) {
    return await mutation.mutateAsync({
      id,
      payload: {
        ...payload,
        person: payload.person[1],
      },
    });
  }

  function handleSuccess({ id }: JudgeWrite) {
    navigate(`../${id}`);
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera domare" />

      <PageLayout.Section>
        <RefereeForm
          onSuccess={handleSuccess}
          onSubmit={handleSubmit}
          defaultValues={{
            person: [`${data.person.first_name} ${data.person.last_name} (${data.person.club.name})`, data.person.id],
            status: data.status ?? 'unknown',
            book: data.book!,
          }}
          mode="edit"
        />
      </PageLayout.Section>
    </Fragment>
  );
});
